import { CircularSpinner } from "@/components/circular-spinner";

export function KLoadingView() {
    return (
        <div className="flex h-full w-full items-center justify-center">
            <CircularSpinner className="size-10" />
        </div>
    );
}
